{
  "dismiss": "Atmesti"
}